import { IAppConfigWithRequestedBUIDKeys } from '~domain/entities/IConfig';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/LoyaltyService';

export class LoyaltyServiceStartedUseCase {
    private configRepository: ConfigRepository;
    private configs: IAppConfigWithRequestedBUIDKeys;

    constructor(configs: IAppConfigWithRequestedBUIDKeys) {
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.configs = configs;
    }

    public execute = async () => {
        await this.configRepository.fetchConfigs(this.configs);
    };
}
